import React from 'react';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { useTheme } from '@mui/material/styles';
import selectionProcessStepsData from '../../constants/team/selection-process-steps';
import AlternatingStepper from '../../components/steppers/AlternatingStepper';
import { STACK_CENTER_COLUMN_DIRECTION } from '../../constants/mui-components';
import {
  containerStack,
  contentStack,
  titleContainer,
  titleTypography,
  stepperContainer,
} from './styles/selection-process-steps.styles';

function SelectionProcessSteps() {
  const theme = useTheme();
  return (
    <Stack
      className={STACK_CENTER_COLUMN_DIRECTION}
      sx={containerStack}
    >
      <Stack
        className={STACK_CENTER_COLUMN_DIRECTION}
        sx={contentStack(theme)}
      >
        <Stack
          className={STACK_CENTER_COLUMN_DIRECTION}
          sx={titleContainer}
        >
          <Typography variant="xlarge_2" sx={titleTypography}>
            {selectionProcessStepsData.title}
          </Typography>
        </Stack>
        <Stack sx={stepperContainer}>
          <AlternatingStepper
            steps={selectionProcessStepsData.steps}
            handleClick={() => {}}
            staticMode
            iconSize="3.75rem"
          />
        </Stack>
      </Stack>
    </Stack>
  );
}

export default SelectionProcessSteps;
